<template>
  <div class="pa-3">
    <!-- chọn xe -->
    <v-layout wrap class="mb-3">
      <v-flex xs12 sm6>
        <v-autocomplete
          :items="vehicleOptions"
          v-model="selectedVehicleId"
          label="Tìm xe theo biển số"
          item-text="label"
          item-value="value"
          dense
          outlined
          clearable
          hide-no-data
          no-data-text="Không tìm thấy xe"
          :search-input.sync="vehicleQuery"
          :filter="vehicleFilter"
          prepend-inner-icon="search"
          @change="onSelectVehicle"
        >
          <template v-slot:item="{ item }">
            <div class="d-flex align-center">
              <div class="mr-2"><strong>{{ item.label }}</strong></div>
            </div>
          </template>
          <template v-slot:selection="{ item }">
            <span>{{ item.label }}</span>
          </template>
        </v-autocomplete>
      </v-flex>
    </v-layout>

    <!-- Hiển thị xe đang chọn -->
    <div v-if="selVehicle" class="mb-2">
      <v-chip color="primary" text-color="white" small>
        Đang chọn xe:
        <strong class="ml-2">{{ plate }}</strong>
        <span class="ml-2"> (Id: {{ selVehicle.Id }})</span>
        <span v-if="selVehicle.Name" class="ml-2">- {{ selVehicle.Name }}</span>
      </v-chip>
    </div>

    <div v-if="selVehicle">
      <p class="caption grey--text">
        Khách hàng: {{ name }} — Biển số: <strong>{{ plate }}</strong><br>
        Thiết bị: {{ deviceList.length }}
      </p>

      <template v-if="deviceList && deviceList.length > 0">
        <v-tabs v-model="deviceTab" color="primary" dark fixed-tabs>
          <v-tab v-for="(d, idx) in deviceList" :key="dKey(d, idx)">
            {{ d.Imei }}
          </v-tab>

          <!--Tab send command-->
          <v-tab
            v-if="showSendCommandTab"
            key="send-command-tab"
          >
            Gửi lệnh
          </v-tab>

          <v-tab-item v-for="(d, idx) in deviceList" :key="`tabitem-${dKey(d, idx)}`">
            <v-card flat class="pa-3">
              <div class="mb-2">
                <div><strong>DeviceId:</strong> {{ d && d.Id }}</div>
                <div><strong>DeviceTypeId:</strong> {{ d && d.DeviceTypeId }}</div>
                <div><strong>UnitId:</strong> {{ (d && d.UnitId) || '--' }}</div>
                <div><strong>Imei:</strong> {{ (d && d.Imei) || '--' }}</div>
              </div>

              <v-divider class="my-3"></v-divider>
              <div>
                <h3 class="subtitle-1 mb-2">
                  Gói tin ({{ filteredMessages(d.UnitId).length }})
                </h3>
                <v-card outlined class="pa-2"
                  @wheel.stop
                  @touchmove.stop
                  style="
                    max-height: calc(100vh - 250px);
                    overflow: auto;
                  ">
                  <div
                    v-for="(m, midx) in filteredMessages(d.UnitId)"
                    :key="midx"
                    class="mb-2 pa-1"
                    style="border-bottom: 1px solid #ddd;"
                  >
                    <div><strong>Unit:</strong> {{ m.unitId }}</div>
                    <div><strong>Time:</strong> {{ convertSecond2010ToDateTime(m.gpsTime) }}</div>
                    <div><strong>Speed:</strong> {{ m.speed / 100 }}</div>
                    <div><strong>Location:</strong> {{ m.info }}</div>
                    <div><strong>Data:</strong> {{ m.data }}</div>
                  </div>
                </v-card>
              </div>

            </v-card>
          </v-tab-item>

          <!--Send command detail -->
          <v-tab-item
            v-if="showSendCommandTab"
            key="tabitem-send-command"
          >
            <v-card flat class="pa-4">
              <v-card-title primary-title>
                <div>
                  <h3 class="headline mb-0">Gửi lệnh tới thiết bị</h3>
                  <div class="caption grey--text">Chọn thiết bị và gửi lệnh xuống</div>
                </div>
              </v-card-title>
              <v-card-text>
                <v-form ref="form" v-model="isFormValid" lazy-validation>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-select
                        :items="deviceOptions"
                        v-model="selectedDevice"
                        label="Chọn thiết bị (IMEI)"
                        item-text="label"
                        item-value="value"
                        dense
                        outlined
                        clearable
                      />
                    </v-flex>

                    <v-flex xs12>
                      <v-text-field
                        v-model="messageCommand"
                        :rules="[rules.required]"
                        placeholder="Nhập lệnh..."
                        dense
                        outlined
                        clearable
                        validate-on-blur
                        append-icon="send"
                        @click:append="sendCommand"
                      />
                    </v-flex>

                    <v-flex xs12 class="text-right">
                      <v-btn color="primary" :disabled="!canSend" @click="sendCommand">Gửi lệnh</v-btn>
                    </v-flex>
                  </v-layout>
                </v-form>

                <v-divider class="my-4"></v-divider>

                <h4 class="subtitle-1 mb-2">Lịch sử lệnh</h4>
                <div v-if="commandInfo && commandInfo.length"
                  class="command-history"
                  @wheel.stop
                  @touchmove.stop>
                  <div v-for="(cmd, index) in commandInfo" :key="index" class="mb-2">
                    <div>
                      <strong>Ngày:</strong> {{ formatGMTToLocalTime(cmd.createdDate) }}
                      &nbsp;—&nbsp;
                      <strong>Thiết bị trả lời:</strong> {{ cmd.isRequest ? 'Có' : 'Không' }}
                    </div>
                    <div><strong>Nội dung:</strong> {{ cmd.message }}</div>
                    <v-divider class="my-2" />
                  </div>
                </div>
                <div v-else class="text-center grey--text">
                  Chưa có dữ liệu lịch sử cho thiết bị này.
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </template>
    </div>

  </div>
</template>

<script>

import { mapActions } from 'vuex'
import * as signalR from '@microsoft/signalr/dist/browser/signalr';
import { formatGMTToLocalTime } from '@/utils/datetime';

export default {
  name: 'MonitorPackage',
  props: {
    name: String,
    id: [String, Number],
    vehicles: {
      type: Array,
      default: () => []
    },
    vehicleId: [String, Number],
    devices: Array
  },
  data () {
    return {
      deviceTab: 0,
      selectedVehicleId: null,
      vehicleQuery: '',
      hubConnection: null,
      messages: [],
      selectedDevice: null,
      messageCommand: '',
      isFormValid: true,
      commandInfo: [],
      rules: {
        required: v => (!!v && String(v).trim().length > 0) || 'Bắt buộc'
      }
    }
  },

  async mounted () {
    await this.initSignalR()
  },

  beforeDestroy () {
    if (this.hubConnection) this.hubConnection.stop()
  },

  computed: {
    showSendCommandTab () {
      const devices = this.deviceList || []
      if (devices.length === 1) return true
      return devices.length > 1 && this.deviceTab >= 0
    },


    deviceOptions () {
      return (this.deviceList || []).map(d => ({
        label: d.Imei || d.Serial || d.Id,
        value: d.Id
      }))
    },
    canSend () {
      return !!(this.selectedDevice && this.messageCommand)
    },

    // build options for v-select
    vehicleOptions () {
      const list = Array.isArray(this.vehicles) ? this.vehicles : []
      return list.map(v => ({
        value: v && v.Id != null ? String(v.Id) : null,
        label: v ? (v.Plate || v.LicensePlate || v.PlateNumber || v.Name || (`#${v.Id}`)) : 'Unknown'
      }))
    },

    // resolve selected id: prefer prop vehicleId if provided (sync from parent)
    resolvedVehicleId () {
      return this.vehicleId != null ? String(this.vehicleId) : this.selectedVehicleId
    },

    selVehicle () {
      const list = Array.isArray(this.vehicles) ? this.vehicles : [];
      const idStr = this.resolvedVehicleId != null ? String(this.resolvedVehicleId) : null;
      return idStr ? list.find(v => v && String(v.Id) === idStr) || null : null;
    },

    plate () {
      const v = this.selVehicle
      if (!v) return ''
      return v.Plate || v.LicensePlate || v.PlateNumber || '—'
    },

    deviceList () {
      const v = this.selVehicle
      if (v && Array.isArray(v.Devices) && v.Devices.length > 0) {
        
        return v.Devices
      }
      const all = Array.isArray(this.devices) ? this.devices : []
      if (v && v.Id != null) {
        const idStr = String(v.Id)
        return all.filter(d => d && String(d.VehicleId) === idStr)
      }
      return []
    }
  },
  
  watch: {
    selVehicle () {
      this.deviceTab = 0
    },
    // keep local select in sync when parent changes vehicleId
    vehicleId (nv) {
      this.selectedVehicleId = nv != null ? String(nv) : null
    },
    selectedDevice: {
      immediate: false,
      handler (nv) {
        if (!nv) {
          this.commandInfo = null
          return
        }
        const device = Array.isArray(this.devices)
          ? this.devices.find(d => d && String(d.Id) === String(nv))
          : null
        const imei = device ? (device.Imei || device.Serial || device.Id) : null
        if (!imei) {
          this.commandInfo = null
          return
        }

        this.GetCommandByImei({ imei })
          .then(res => {
            this.commandInfo = res && res.data ? res.data : res
          })
          .catch(err => {
            this.commandInfo = null
            this.snack = { show: true, text: `Lấy info IMEI ${testImei} thất bại` }
          })
      }
    }
  },
  methods: {
    ...mapActions(['GetCommandByImei', 'SendCommandToDevice']),
    formatGMTToLocalTime,
    convertSecond2010ToDateTime (secondsFrom2010) {
      if (!secondsFrom2010) return '-'
      try {
        const base = new Date(2010, 0, 1, 0, 0, 0)
        const ms = Number(secondsFrom2010) * 1000
        const date = new Date(base.getTime() + ms)

        const yyyy = date.getFullYear()
        const MM = String(date.getMonth() + 1).padStart(2, '0')
        const dd = String(date.getDate()).padStart(2, '0')
        const HH = String(date.getHours()).padStart(2, '0')
        const mm = String(date.getMinutes()).padStart(2, '0')
        const ss = String(date.getSeconds()).padStart(2, '0')

        return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`
      } catch (e) {
        return String(secondsFrom2010)
      }
    },

    filteredMessages (unitId) {
      if (!unitId || !Array.isArray(this.messages)) return []
      return this.messages.filter(m => String(m.unitId) === String(unitId))
    },
 
    async initSignalR () {
      try {
        this.isHubReady = false
        this.hubConnection = new signalR.HubConnectionBuilder()
          .withUrl(`${process.env.MONITOR_HUB}/hub/monitor-package`)
          .withAutomaticReconnect()
          .build()

        this.hubConnection.on('ReceivePacket', (packet) => {

          if (Array.isArray(packet)) {
            packet.forEach(p => {
              this.messages.unshift(p)
            })
          } else {
            this.messages.unshift(packet)
          }

          if (this.messages.length > 100) {
            this.messages = this.messages.slice(0, 100)
          }
          this.messages.sort((a, b) => Number(b.gpsTime || 0) - Number(a.gpsTime || 0))
        })


        this.hubConnection.on('Subscribed', (unitId) => {
        })

        this.hubConnection.on('Unsubscribed', (unitId) => {
        })

        await this.hubConnection.start()
        this.isHubReady = true
      } catch (err) {
      }
    },

    async subscribeToUnit (unitId) {
      if (!this.hubConnection) return
      try {
        await this.hubConnection.invoke('SubscribeUnit', unitId)
      } catch (err) {
      }
    },

    async unsubscribeFromUnit (unitId) {
      if (!this.hubConnection) return
      try {
        await this.hubConnection.invoke('UnsubscribeUnit', unitId)
      } catch (err) {
      }
    },

    _slug (s) {
      if (!s) return ''
      return String(s)
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/đ/g, 'd').replace(/Đ/g, 'D')
        .toLowerCase()
    },

    vehicleFilter (item, queryText, itemText) {
      const q = this._slug(queryText)
      const hay = this._slug(item.search || itemText || '')
      return hay.includes(q)
    },

    async onSelectVehicle (val) {
      this.deviceTab = 0
      const sel = this.selVehicle

      this.$emit('vehicle-selected', { companyId: this.id, vehicle: sel })

      if (!sel) {
        if (this._lastSubscribedUnits && this._lastSubscribedUnits.length > 0) {
          for (const oldId of this._lastSubscribedUnits) {
            await this.unsubscribeFromUnit(oldId)
          }
        }
        this.messages = []
        this._lastSubscribedUnits = []
        return
      }

      const devices = Array.isArray(sel.Devices)
        ? sel.Devices
        : (Array.isArray(this.devices)
            ? this.devices.filter(d => String(d.VehicleId) === String(sel.Id))
            : [])

      if (!devices.length) {
        return
      }

      const unitIds = devices
        .map(d => d && d.UnitId)
        .filter(u => !!u && u.trim() !== '')

      // 🔹 unsubscribe old ones
      // if (this._lastSubscribedUnits && this._lastSubscribedUnits.length > 0) {
      //   for (const oldId of this._lastSubscribedUnits) {
      //     if (!unitIds.includes(oldId)) {
      //       await this.unsubscribeFromUnit(oldId)
      //     }
      //   }
      // }

      // 🔹 subscribe new ones
      // if (this.hubConnection && this.hubConnection.state === signalR.HubConnectionState.Connected) {
      //   for (const unitId of unitIds) {
      //     console.log('📡 Subscribing to unitId:', unitId)
      //     await this.subscribeToUnit(unitId)
      //   }
      // } else {
      //   console.warn('⚠️ Hub not connected yet.')
      // }

      // this._lastSubscribedUnits = unitIds

      if (!this.isHubReady) {
        console.warn('⚠️ Hub not ready, waiting...')
        const waitHub = () => new Promise(resolve => {
          const timer = setInterval(() => {
            if (this.isHubReady) { clearInterval(timer); resolve() }
          }, 300)
        })
        await waitHub()
      }

      for (const unitId of unitIds) {
        await this.subscribeToUnit(unitId)
      }

      this._lastSubscribedUnits = unitIds
    },

    dKey (d, idx) {
      return (d && (d.Id || d.Imei || d.Serial)) ? (d.Id || d.Imei || d.Serial) : `idx-${idx}`
    },
    async sendCommand () {
      try {
        const okForm = await this.$refs.form.validate();
        if (!okForm) return;

        const device = Array.isArray(this.devices)
          ? this.devices.find(d => d && String(d.Id) === String(this.selectedDevice))
          : null;
        const imei = device ? (device.Imei) : null;

        if (!imei) {
          this.snack = { show: true, text: 'Thiếu IMEI thiết bị' };
          return;
        }

        const data = {
          imei: String(imei),
          deviceId: (device && device.Id != null) ? device.Id : 0,
          vehicleId: (device && device.VehicleId != null) ? device.VehicleId : 0,
          deviceType: (device && device.DeviceType != null) ? device.DeviceType : 0,
          message: this.messageCommand
        };

        const responseSend = await this.SendCommandToDevice(data).catch(() => false);
        if (responseSend) {
          const res = await this.GetCommandByImei({ imei: String(imei) });
          this.commandInfo = res && res.data ? res.data : res;
          this.messageCommand = ''; 
          this.$nextTick(() => this.$refs.form.resetValidation());
          window.getApp.showMessage('Gửi lệnh thành công.', 'success');
        }
      } catch (e) {
        window.getApp.showMessage('Gửi lệnh thất bại.', 'error');
      }
    },
  },
}
</script>
<style scoped>
.device-details div { margin-bottom: 6px; }
.command-history {
  max-height: 50vh;
  overflow-y: auto;
}

</style>



// WEBPACK FOOTER //
// src/pages/search/components/MonitorPackage.vue